import { useEffect, useState, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "./auth-service";
import { AuthProvider } from "./AuthContext";
import type { AuthUser } from "./types";

export function AuthGuard({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const [user, setUser] = useState<AuthUser | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    getCurrentUser()
      .then((u) => {
        if (!u) navigate("/login", { replace: true, state: { sessionExpired: true } });
        else setUser(u);
      })
      .catch(() => {
        navigate("/login", { replace: true });
      })
      .finally(() => setChecking(false));
  }, [navigate]);

  if (checking) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-text-secondary text-sm">Loading...</p>
      </div>
    );
  }

  if (!user) return null;
  return <AuthProvider value={user}>{children}</AuthProvider>;
}
